import turfObj from "@turf/along";

export default function along(line, distance, options) {
    return turfObj(line, distance, options);
};
